import React from "react";
import { FixedSizeList as List } from 'react-window';
const FileViewer = ({ fileContent }) => {
   
    if (!fileContent) return <span style={{ color: '#888' }}>No content</span>;

    const lines = fileContent.split('\n');

    return (
        <div style={{ height: '600px', width: '100%' }}>
            <List
                height={600}
                itemCount={lines.length}
                itemSize={20} // adjust line height
                width="100%"
            >
                {({ index, style }) => (
                    <div style={{ ...style, fontFamily: 'monospace', whiteSpace: 'pre' }}>
                        {lines[index]}
                    </div>
                )}
            </List>
        </div>
    );
};

export default FileViewer;